<template>
    <div class="assign">
        <b-modal id="assign-users-modal"
                 title="Add users to project"
                 ok-title="Confirm"
                 :ok-disabled="assignedUsers.length === 0"
                 size="md"
                 centered
                 @ok="assignUsers"
                 @show="loadAssignableUsers">
            <b-form v-if="assignableUsers.length > 0">
                <div class="row">
                    <div class="col-sm-9">
                        <b-form-select
                            class="mb-5 mr-sm-3 mb-sm-0"
                            :options="assignableUsers"
                            v-model="selected"
                            value-field="id"
                            text-field="name"
                            required>
                            <template #first>
                                <b-form-select-option :value="null" disabled>Select user...</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>

                    <div class="col-sm-3">
                        <b-button
                            class="mb-2 mr-sm-2 mb-sm-0 fit-width"
                            variant="primary"
                            :disabled="!selected"
                            @click="addSelectedUser">
                            Add
                        </b-button>
                    </div>
                </div>
            </b-form>

            <h5 v-else>No users available to assign.</h5>

            <div v-if="assignedUsers.length > 0">
                <hr/>
                <h6>The following users will be added:</h6>

                <b-list-group>
                    <b-list-group-item v-for="(user, index) in assignedUsers" :key="user.id">
                        {{ user.name }}

                        <b-button
                            variant="danger"
                            size="sm"
                            class="pull-right"
                            @click="removeAssignedUser(user, index)">
                            Remove
                        </b-button>
                    </b-list-group-item>
                </b-list-group>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: {
            project: {
                type: Object,
                required: true
            }

        },
        data() {
            return {
                selected: null,
                assignableUsers: [],
                assignedUsers: []
            }
        },
        computed: {},
        mounted() {
        },
        methods: {
            loadAssignableUsers() {
                this.$store.dispatch('loadUsers').then((users) => {
                    this.assignableUsers = [];
                    let that = this;

                    this.assignableUsers = users.filter(user => {
                        const foundIndex = that.project.assigned_users.findIndex(assigned_user => {
                            return assigned_user.id === user.id;
                        });
                        return foundIndex === -1;
                    });
                });
            },

            assignUsers() {
                let token = this.$store.state.token;
                let url = this.$store.getters.apiBase + '/projects/' + this.project.id + '/users/assign-multiple';
                let method = 'POST';

                axios({
                    url: url,
                    data: {
                        users: this.assignedUsers
                    },
                    method: method,
                    headers: {"Authorization": "Bearer " + token}
                })
                    .then(response => {
                        let users = response.data.data;
                        this.assignedUsers = [];
                        this.$emit('ok', users);
                    })
                    .catch(error => {
                        alert('Something went wrong');
                        console.log(error);
                    });
            },
            addSelectedUser() {
                let that = this;

                this.assignableUsers = this.assignableUsers.filter(user => {
                    if (user.id === that.selected) {
                        that.assignedUsers.push(user);
                        return false;
                    }
                    return true;
                });
                this.selected = null;

            },
            removeAssignedUser(user, userIndex) {
                this.assignableUsers.push(user);
                this.assignedUsers.splice(userIndex, 1);
                this.sortUsers();
            },
            sortUsers() {
                this.assignableUsers.sort((a, b) => {
                    if (a.text < b.text) {
                        return -1;
                    }
                    if (a.text > b.text) {
                        return 1;
                    }
                    return 0;
                });
            }

        },
        watch: {
        },
    }
</script>
<style scoped>
    .pull-right{
        float: right;
    }
</style>
